import axios from 'axios';
import { DASHBOARD_API } from './service';

export const getCalendarEvents = () => {
    const url = `${DASHBOARD_API}/events`;
    const response = axios.get(url);
    return response;
};
